import { render } from "./ModalUploadPdfElaborazione.vue?vue&type=template&id=4a2d4c8a&scoped=true"
import script from "./ModalUploadPdfElaborazione.vue?vue&type=script&lang=js"
export * from "./ModalUploadPdfElaborazione.vue?vue&type=script&lang=js"

import "./ModalUploadPdfElaborazione.vue?vue&type=style&index=0&id=4a2d4c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2d4c8a"]])

export default __exports__